export enum ReturnTypeConstants {
  EXCESS_RETURN = 'EXCESS_RETURN',
  PRICE_RETURN = 'PRICE_RETURN',
  TOTAL_RETURN = 'TOTAL_RETURN',
}
